export default __webpack_public_path__ + "static/media/travily-2.d749c4f5.PNG";